module.exports = "/_next/static/images/freecharge-monotone-cd841cf2531a59c3cb26d76d9bbe01e0.svg";